<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_12 col_34'><span class='brt high default' id='text1'>NRPC - STARS</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S100G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_12 col_34'><span class='brt high default' id='text3'>OPTIONS MENU</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_05 col_29'><span class='brt high default' id='text4'>ENTER</span>  </div>
  <div class='lgr_10 col_35'><span class='brt high default' id='text5'>SELECTION:</span>  </div>
  <div class='lgr_00 col_46'>  </div>
  <div class='lgr_01 col_48'><dynamic-field [id]='"select"' [size]=1 [line]=6 [column]=48 [(ngModel)]='select' (ngModelChange)="selectChange()"></dynamic-field></div>
  <div class='lgr_00 col_50'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_17 col_29'><span class='brt high default' id='text8'>1. TICKET INQUIRY</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_29'><span class='brt high default' id='text9'>2. FAREPLAN AND USA RAIL PASS REPORTS   </span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_23 col_29'><span class='brt high default' id='text10'>3.                     </span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_23 col_29'><span class='brt high default' id='text11'>4. ADMINISTRATION      </span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text12'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text13'>4-EXIT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text14'>SHIFT PF:</span>  </div>
</div>
</div>
